import { useEffect, useState } from 'react';

/**
 * True only after the component has mounted client-side. Used to defer
 * client-time-dependent calculations (e.g. EDD cutoff/date resolution, AC24-25-28
 * of story 158621) so the server-rendered/cached HTML never embeds a resolved
 * date computed with the server's clock or timezone.
 */
export const useIsClient = (): boolean => {
	const [isClient, setIsClient] = useState(false);
	useEffect(() => setIsClient(true), []);
	return isClient;
};
